/* eslint-disable function-paren-newline */
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import * as types from '@/store/mutation-types';
import ningxia from './index.ningxia';
import defaultRoute from './index.defaultRoute';
import { sourceNingxiaUrl } from '@/utils/utils';
Vue.use(VueRouter);
const sourceNingxia = sourceNingxiaUrl();
const routes = [
  {
    path: '/',
    redirect: sourceNingxia ? '/dataAnalysisLogin' : '/login',
  },
  ...ningxia,
  ...defaultRoute,
];

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

const showOutCallComponent = () => {
  const divCallPhone = document.querySelector('.fix-out-call');
  divCallPhone && (divCallPhone.style.display = 'block');
};

let pageStack = [];
let fullPathStack = [];
router.beforeEach((to, from, next) => {
  // 检查URL参数是否包含platform=qw
  const urlParams = new URLSearchParams(window.location.hash.split('?')[1] || '');
  if (urlParams.get('platform') === 'qw') {
    window.platform = 'qw';
  }

  pageStack.push(to.path);
  fullPathStack.push(to.fullPath);
  if (fullPathStack.length > 2) {
    pageStack = pageStack.slice(-2);
    fullPathStack = fullPathStack.slice(-2);
  }

  // if (pageStack.length === 1) {
  //   const list = [
  //     '/default/afterDiagnosisPlanDetail',
  //     '/default/detail',
  //     '/default/intelligentFollowUpDetail',
  //     '/default/patientdetails',
  //     '/default/toolsInHospitalDetail',
  //     '/default/specialDiseaseLibraryPatientList',
  //     '/default/preInquiryPatientDetails',
  //   ];
  //   if (list.includes(to.path)) {
  //     const lastUrl = JSON.parse(sessionStorage.getItem('path'));
  //     if (!lastUrl) {
  //       // 其他窗口
  //       router.replace({
  //         path: '/default/workbench',
  //       });
  //     } else {
  //       // 本窗口
  //       router.replace({
  //         path: lastUrl[0],
  //       });
  //     }
  //   }
  // }
  // sessionStorage.setItem('path', JSON.stringify(fullPathStack));
  const showOutCall = store.state.outCallIng;
  if (to.fullPath.match('/default/intelligentFollowUpDetail') && showOutCall) {
    if (showOutCall) {
      showOutCallComponent();
    }
    next();
    return;
  }
  // 院内数据分组管理跳转回患者列表
  if (to.path === '/default/toolsInHospitalList') {
    if (from.query.groupId) {
      store.commit('SET_IN_HOSPITAL_SELECT_LIST', []);
    }
  }
  // 宁夏上呼吸道项目路由
  if (sourceNingxia) {
    const loginPage = to.fullPath.match('dataAnalysisLogin') || [];
    const ningXiaPages = to.fullPath.match('/dataDefault') || [];
    if (loginPage.length > 0 || ningXiaPages.length > 0) {
      document.title = '数据分析平台';
      const progresPage = to.fullPath.match('dataDefault/progress') || [];
      const datePage = to.fullPath.match('dataDefault/data') || [];
      if (JSON.parse(localStorage.getItem('CenterAdmin'))) {
        if (loginPage.length > 0 || progresPage.length > 0 || datePage.length > 0) {
          next();
        } else {
          return;
        }
      }
      next();
    } else {
      return;
    }
  }

  if (showOutCall) {
    showOutCallComponent();
  }

  store.commit(types.SET_CURRENT_ROUTER, to);
  next();
});

// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;

// 解决编程式路由往同一地址跳转时会报错的情况
const originalReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

export default router;
